import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/styles/tokens.css";
import { App } from "@/app/App";
import { createServices } from "@/lib/services";
import { registerSW } from "virtual:pwa-register";

const root = document.getElementById("root");
if (!root) {
  throw new Error("index.html has no #root element to mount into");
}

createRoot(root).render(
  <StrictMode>
    <App services={createServices()} />
  </StrictMode>,
);

// The service worker caches the app for speed and offline use. With autoUpdate
// it activates a new deploy as soon as it is found and reloads once, so nobody
// — least of all someone arriving from an ad — keeps seeing yesterday's build.
// First-run answers survive the reload: the draft lives in localStorage.
registerSW({ immediate: true });
